import { render, staticRenderFns } from "./AlotCredit.vue?vue&type=template&id=6a32385c&scoped=true"
import script from "./AlotCredit.vue?vue&type=script&lang=js"
export * from "./AlotCredit.vue?vue&type=script&lang=js"
import style0 from "./AlotCredit.vue?vue&type=style&index=0&id=6a32385c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a32385c",
  null
  
)

export default component.exports